import { Ribbon, Sparkle } from "./Decorations";

export default function Message() {
  return (
    <section
      id="message"
      data-testid="message-section"
      className="relative py-28 bg-lavender-bg overflow-hidden"
    >
      <span
        className="float-shape animate-float"
        style={{ width: 260, height: 260, background: "#C7A5D9", top: -40, right: -60 }}
      />
      <span
        className="float-shape animate-float"
        style={{ width: 200, height: 200, background: "#DDEBF0", bottom: -40, left: -40, animationDelay: "3s" }}
      />
      <Sparkle className="absolute top-16 left-1/4" color="#8E44AD" size={20} />
      <Sparkle className="absolute bottom-20 right-1/4" color="#C7A5D9" size={16} />

      <div className="relative max-w-4xl mx-auto px-5 lg:px-10 text-center">
        <p className="pill mb-5 reveal">A Personal Note</p>
        <h2
          className="h-display text-3xl sm:text-4xl title-underline reveal"
          data-testid="message-title"
        >
          My Message
        </h2>

        <p className="mt-10 text-lg sm:text-xl leading-relaxed text-charcoal/85 reveal-blur">
          Dr. Maggie's mission is to inspire, educate, and empower individuals living with arthritis
          and autoimmune diseases. Her goal is to help people better understand their bodies, ask
          the right questions, and take an active role in their health journey. She is especially
          passionate about supporting women and minority communities who are disproportionately
          affected by autoimmune and rheumatologic conditions.
        </p>

        <div className="mt-12 inline-flex flex-col items-center reveal-scale">
          <div className="w-48 opacity-70 mb-1">
            <Ribbon color="#6F2DA8" />
          </div>
          <span className="signature text-5xl sm:text-6xl text-royal leading-none">
            Dr. Maggie
          </span>
        </div>
      </div>
    </section>
  );
}
